import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../../reducers/reducer";
import OverviewTableConstructionView from "../../../views/DashboardView/CardView/AllocationView/MultiStepView/components/OverviewTableConstruction";

interface Props {
  construction_quantities_hvo: any;
  construction_quantities_fame: any;
  construction_quantities_etanol: any;
  construction_quantities_nafta: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      construction_quantities_hvo:
        state.card.allocation.multiStep.construction_quantities_hvo,
      construction_quantities_fame:
        state.card.allocation.multiStep.construction_quantities_fame,
      construction_quantities_etanol:
        state.card.allocation.multiStep.construction_quantities_etanol,
      construction_quantities_nafta:
        state.card.allocation.multiStep.construction_quantities_nafta,
    }),
    (dispatch: any) => ({
      dispatch,
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {},
  })
)(OverviewTableConstructionView);
